const ENV_PLACEHOLDER_REGEX = /^__VITE_[A-Z0-9_]+__$/

const isValidEnvValue = (value: unknown) =>
  typeof value === "string" ? value.length > 0 && !ENV_PLACEHOLDER_REGEX.test(value) : value !== undefined

const pickEnvVar = (key: string, runtimeEnv: Record<string, unknown>) => {
  const viteEnv = import.meta.env[key]
  const runtimeValue = runtimeEnv[key]

  if (import.meta.env.DEV) {
    if (isValidEnvValue(viteEnv)) return viteEnv
    else {
      console.warn(`Env var ${key} is missing or invalid in Vite env vars.`)
    }
  } else {
    if (isValidEnvValue(runtimeValue)) return runtimeValue
    else {
      console.warn(`Env var ${key} is missing or invalid in runtime env vars.`)
    }
  }

  return undefined
}

const loadEnvVars = () => {
  const runtimeEnv = window.__env__ || {}
  const auth0Domain = pickEnvVar("VITE_AUTH0_DOMAIN", runtimeEnv)
  const auth0ClientId = pickEnvVar("VITE_AUTH0_CLIENT_ID", runtimeEnv)
  const auth0Audience = pickEnvVar("VITE_AUTH0_AUDIENCE", runtimeEnv)
  const auth0RedirectUri = `${window.location.origin}`
  const graphqlApiGateway = pickEnvVar("VITE_GRAPHQL_API_GATEWAY_URL", runtimeEnv)
  const sentryDsn = pickEnvVar("VITE_SENTRY_DSN", runtimeEnv)
  const env = pickEnvVar("VITE_ENVIRONMENT", runtimeEnv)

  if (import.meta.env.MODE === "test" || import.meta.env.NODE_ENV === "test") {
    return {
      auth0Domain: "login.qa.bancacfplus.it",
      auth0ClientId: "T26SvlF2AwElHIYVbJG7FX8TSBbe6xFC",
      auth0Audience: "https://qa.bancacfplus.it/",
      auth0RedirectUri,
      graphqlApiGateway,
      sentryDsn: ""
    }
  }

  if (!auth0Domain || !auth0ClientId || !auth0Audience || !auth0RedirectUri || !graphqlApiGateway) {
    throw new Error(`Missing env vars`)
  }

  return {
    auth0Domain,
    auth0ClientId,
    auth0Audience,
    auth0RedirectUri,
    graphqlApiGateway,
    sentryDsn,
    env
  }
}

export { loadEnvVars }
